import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import axios from 'axios'
import { FaCheck, FaTimes } from 'react-icons/fa'

import services from '../services'
import { APIURL } from '../../constants'
import { formatStripeAmount } from '../advisor/utils'

let _couponCheck

const checkCoupon = async (coupon, planId, priceId) => {
  try {
    if (_couponCheck) {
      _couponCheck.cancel()
    }
    _couponCheck = axios.CancelToken.source()
    let data = null
    if (coupon) {
      const url = `${APIURL.API_STRIPE_CHECK_COUPON}${encodeURIComponent(
        coupon
      )}/`
      data = await services.get_v2(url, {
        params: {
          cancelToken: _couponCheck.token,
          plan_id: planId,
          price_id: priceId
        }
      })
    }
    if (data && data.status === 'success') {
      const { percent_off, amount_off } = data.response
      return {
        coupon,
        valid: true,
        percent_off,
        amount_off,
        duration: data.response.duration
      }
    } else if (coupon === '' || coupon === null || coupon === undefined) {
      return {
        coupon,
        valid: null,
        percent_off: null,
        amount_off: null,
        duration: null,
        message: ''
      }
    } else if (data.message) {
      return {
        coupon,
        valid: false,
        percent_off: null,
        amount_off: null,
        duration: null,
        message: data.message
      }
    } else {
      return {
        coupon,
        valid: false,
        percent_off: null,
        amount_off: null,
        duration: null,
        message: 'Invalid Coupon code!'
      }
    }
  } catch (e) {
    console.error(e)
  }
  return {
    coupon,
    valid: null,
    percent_off: null,
    amount_off: null,
    duration: null,
    message: ''
  }
}

const CouponCode = ({ coupon_code, planId, priceId, onChange, couponData }) => {
  const [couponValue, setCouponValue] = useState(coupon_code)
  const [firstLoad, setFirstLoad] = useState(true)

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false)
    }
    couponValidate(coupon_code)
  }, [coupon_code, firstLoad, setFirstLoad])

  const couponValidate = async (coupon) => {
    setCouponValue(coupon)
    const couponData = await checkCoupon(coupon, planId, priceId)
    onChange(couponData)
  }

  const handleChange = async (e) => {
    const coupon = e.target.value.toUpperCase()
    couponValidate(coupon)
  }

  const renderStatus = () => {
    const { valid, percent_off, amount_off, duration } = couponData
    if (valid === null) {
      return
    }
    if (valid) {
      const message = percent_off ? (
        <div>
          Coupon is valid. You will save <strong>{percent_off}%!</strong>
          <span className={classNames({ 'display-none': duration !== 'once' })}>
            {' '}
            (once)
          </span>
        </div>
      ) : (
        <div>
          Coupon is valid. You will save{' '}
          <strong>{formatStripeAmount(amount_off)}</strong>
          <span className={classNames({ 'display-none': duration !== 'once' })}>
            {' '}
            (once)
          </span>
        </div>
      )
      return <small className="coupon-message">{message}</small>
    } else {
      return <small className="coupon-message">{couponData.message}</small>
    }
  }

  const renderIcon = () => {
    const { valid } = couponData
    if (valid === null) {
      return
    }
    if (valid) {
      return <FaCheck className="color-success" />
    } else {
      return <FaTimes className="color-danger" />
    }
  }

  return (
    <div>
      <div className="coupon-code">
        <input
          name="coupon_code"
          onChange={handleChange}
          type="text"
          className="form-control"
          placeholder="Coupon Code"
          autoComplete={'off'}
          value={couponValue || ''}
        />
        {renderIcon()}
      </div>
      <div style={{ padding: '10px 0', display: 'flex', alignItems: 'center' }}>
        {renderStatus()}
        {''}
      </div>
    </div>
  )
}

CouponCode.propTypes = {
  coupon_code: PropTypes.string,
  couponData: PropTypes.object,
  planId: PropTypes.object,
  priceId: PropTypes.object,
  onChange: PropTypes.func
}

export default CouponCode
